import { Body1, ITypographyComponentProps } from '@cian/ui-kit';
import { IconFinanceArrowBoldDown16, IconFinanceArrowBoldUp16 } from '@cian/ui-kit-design-tokens/icons';
import React from 'react';
import leadingImage from './assets/LeadingImage.svg';
import * as styles from './styles.css';
import { IPriceCell } from '../../../../../../types/newbuildingsCompare';
import clsx from 'clsx';

export interface IPriceCellProps {
  cell: IPriceCell;
}

export const PriceCell = ({ cell }: IPriceCellProps): React.JSX.Element => {
  let icon: React.JSX.Element | null = null;
  let textColor: ITypographyComponentProps['color'];

  switch (cell.data?.trend) {
    case 'increase':
      icon = <IconFinanceArrowBoldUp16 color="icon-positive-default" />;
      textColor = 'text-positive-default';
      break;

    case 'decrease':
      icon = <IconFinanceArrowBoldDown16 color="icon-negative-default" />;
      textColor = 'text-negative-default';
      break;

    case 'noChange':
      icon = <img alt="" src={leadingImage} />;
      textColor = 'accent-ghost-primary';
      break;
    default:
      break;
  }

  if (cell.data?.text) {
    return (
      <div className={clsx(styles['cell-container'], styles['container'])}>
        <div className={styles['percent-row-container']}>
          {icon}
          <Body1 color={textColor}>{cell.data?.value}</Body1>
        </div>
        <Body1>{cell.data?.text}</Body1>
      </div>
    );
  }

  return (
    <div className={clsx(styles['cell-container'], styles['no-data-container'])}>
      <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
    </div>
  );
};
